import Vue from 'vue';
import { mediaQueriesMixin, helper } from '@/mixins';
import { formatLandingPageText } from '@/helpers';
import { HERO_COMPONENTS } from '@organisms/HeroBanners/HeroBanner.constants';

export const heroBannerLogic = Vue.extend({
    mixins: [mediaQueriesMixin, helper],
    computed: {
        categoryTitle() {
            return formatLandingPageText(this.category.title);
        },
        heroBannerProps() {
            let imageUrl = null;
            if (this.category.header_banner && this.isMobile()) {
                imageUrl = this.resizeImage(
                    this.category.header_banner,
                    900,
                    600,
                    90
                );
            }

            if (this.category.header_banner && !this.isMobile()) {
                imageUrl = `${this.$globalConstants.imageUrl}/${this.category.header_banner}?d=900x600&q=80`;
            }

            // FRON-1876
            if (
                HERO_COMPONENTS.HeroBannerBeta === this.heroType &&
                this.category['header_banner_beta']
            ) {
                imageUrl = `${this.$globalConstants.imageUrl}/${this.category['header_banner_beta']}?d=900x600&q=80`;
            }

            const articleLandingPage =
                !!this.$globalConstants.host[
                    'smart_consumer_tips_article_list'
                ] && this.category.name === 'default';

            return {
                ...this.$globalConstants.components[this.heroType],
                title: articleLandingPage
                    ? this.$globalConstants.host['smart_consumer_tips_title']
                    : this.categoryTitle,
                subTitle: articleLandingPage
                    ? this.$globalConstants.host['smart_consumer_tips_subtitle']
                    : this.category.description,
                backgroundImage: imageUrl,
            };
        },
    },
});
